import { render, staticRenderFns } from "./tradeCycleSiderBar.vue?vue&type=template&id=aab4acce&scoped=true"
import script from "./tradeCycleSiderBar.vue?vue&type=script&lang=js"
export * from "./tradeCycleSiderBar.vue?vue&type=script&lang=js"
import style0 from "./tradeCycleSiderBar.vue?vue&type=style&index=0&id=aab4acce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab4acce",
  null
  
)

export default component.exports